import styles from './MarketFilterNote.module.css'

/** For a card with no market dimension, whose figures ignore the market filter. */
export const MarketFilterNote = ({
  className,
}: {
  className?: string | undefined
}) => (
  <p className={`${styles.note} ${className ?? ''}`}>Not filtered by market</p>
)
